import React, { useEffect, useRef, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";

// Controlled search box that debounces before calling onSearch, so tables can
// run server-side search without firing a request on every keystroke.
function DebouncedSearchInput({
  onSearch,
  placeholder = "Search",
  delay = 400,
  width = "320px",
}) {
  const [value, setValue] = useState("");
  const timer = useRef(null);
  const onSearchRef = useRef(onSearch);
  onSearchRef.current = onSearch;

  useEffect(() => {
    timer.current = setTimeout(() => {
      onSearchRef.current(value.trim());
    }, delay);
    return () => clearTimeout(timer.current);
  }, [value, delay]);

  return (
    <div
      className="flex items-center gap-2 border border-[#D0D5DD] rounded-lg px-3 h-[44px]"
      style={{ width, maxWidth: "100%" }}
    >
      <SearchIcon sx={{ color: "#667085", fontSize: 20 }} />
      <input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        className="w-full outline-none bg-transparent text-sm"
      />
    </div>
  );
}

export default DebouncedSearchInput;
